import {
  DefinitionsFromApi,
  OverrideResultType,
  TagTypesFromApi
} from '@reduxjs/toolkit/query'
import { generatedApi } from 'app/services/api/generatedApi'
import { IApiSuccessWrapper } from '$/types'

// RTK#3506
type TagTypes = TagTypesFromApi<typeof generatedApi>
type Definitions = DefinitionsFromApi<typeof generatedApi>
type UpdatedDefinitions = Omit<Definitions, 'getApiEsriEsriToken'> & {
  getApiEsriEsriToken: OverrideResultType<
    Definitions['getApiEsriEsriToken'],
    string
  >
}

export const esriApi = generatedApi.enhanceEndpoints<
  TagTypes,
  UpdatedDefinitions
>({
  endpoints: {
    getApiEsriEsriToken: {
      transformResponse: (res: IApiSuccessWrapper<{ esriToken: string }>) => {
        return res.result.esriToken
      }
    }
  }
})

export const { useGetApiEsriEsriTokenQuery: useGetEsriTokenQuery } = esriApi
